/**
 * Шаблон ценника: размер этикетки и что на ней печатается. Шаблоны заданы в
 * приложении, а не в 1С: размеры зависят от принтера и рулона (карточка 102,
 * перенос донора `modules/labels`).
 */
export interface LabelTemplate {
  id: string
  name: string
  /** Ширина и высота этикетки в миллиметрах — ими же меряют рулон. */
  widthMm: number
  heightMm: number
  /** Крупная цена и подложка — акционный ценник. */
  accent: boolean
}

export const LABEL_TEMPLATES: readonly LabelTemplate[] = [
  { id: 'standard', name: 'Ценник стандартный', widthMm: 58, heightMm: 40, accent: false },
  { id: 'small', name: 'Ценник мелкий', widthMm: 30, heightMm: 20, accent: false },
  { id: 'sale', name: 'Акционный', widthMm: 58, heightMm: 40, accent: true },
]

export const DEFAULT_TEMPLATE: LabelTemplate = LABEL_TEMPLATES[0] ?? {
  id: 'standard',
  name: 'Ценник стандартный',
  widthMm: 58,
  heightMm: 40,
  accent: false,
}

export const templateOf = (id: string): LabelTemplate =>
  LABEL_TEMPLATES.find((template) => template.id === id) ?? DEFAULT_TEMPLATE

/**
 * Потолок ценников на одну позицию (карточка 102). Не техническое ограничение:
 * лишний ноль в поле копий сжигает рулон, и заметно это только у принтера.
 * Экран говорит о потолке словами, а не обрезает молча.
 */
export const MAX_LABEL_COPIES = 200

/** Сколько копий допустимо: целое от 1 до потолка. */
export function clampLabelCopies(copies: number): number {
  if (!Number.isFinite(copies)) return 1
  return Math.min(MAX_LABEL_COPIES, Math.max(1, Math.trunc(copies)))
}
